import { Component } from '@angular/core';
import { JeevesOrderCardListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'sjoborg-order-card-list',
    templateUrl: './sjoborg-order-card-list.component.html',
    styleUrls: ['./sjoborg-order-card-list.component.scss'],
    standalone: false
})
export class SjoborgOrderCardListComponent extends JeevesOrderCardListComponent {}
